module.exports = __webpack_public_path__ + "img/60-ABITO-ARIA-SML-RIC.GRECIA-RIC.LIMONE1.22a8e408.jpg";